import type { CaseTaxonomy, WorkCase } from '#shared/types/WorkPage'

export const parseFilterQuery = (value: unknown): string[] => {
    const rawValues = Array.isArray(value) ? value : [value]

    return [...new Set(rawValues
        .flatMap(raw => typeof raw === 'string' ? raw.split(',') : [])
        .map(value => value.trim())
        .filter(Boolean))]
}

export const resolveTaxonomyIds = (slugs: string[], taxonomy: CaseTaxonomy[]): string[] => {
    const idsBySlug = new Map(taxonomy.map(tag => [tag.slug, tag.contentId]))
    return slugs.flatMap(slug => idsBySlug.get(slug) ?? [])
}

export const filterWorkCases = (
    cases: WorkCase[],
    selectedProjectTypeIds: string[],
    selectedThemeIds: string[],
): WorkCase[] => {
    const projectTypeIds = new Set(selectedProjectTypeIds)
    const themeIds = new Set(selectedThemeIds)

    return cases.filter(item => {
        const caseProjectTypes = item.data['project-types'] ?? []
        const caseThemes = item.data.themes ?? []
        const matchesProjectType = projectTypeIds.size === 0
            || caseProjectTypes.some(id => projectTypeIds.has(String(id)))
        const matchesTheme = themeIds.size === 0
            || caseThemes.some(id => themeIds.has(String(id)))

        return matchesProjectType && matchesTheme
    })
}
